
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBatteryVerticalPluggedNoChargeEmpty as ObiBatteryVerticalPluggedNoChargeEmptyElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-battery-vertical-plugged-no-charge-empty.js';
 
 
 

 
 export const ObiBatteryVerticalPluggedNoChargeEmpty = createComponent({
   react: React,
   tagName: 'obi-battery-vertical-plugged-no-charge-empty',
   elementClass: ObiBatteryVerticalPluggedNoChargeEmptyElement,
   events: {
     
   }
  });
 
 